import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appCountUp]',
  standalone: true
})
export class CountUpDirective implements OnChanges {
  @Input('appCountUp') endValue = 0;
  @Input() duration = 1000; // milliseconds

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['endValue']) {
      const end = Number(this.endValue) || 0;
      this.animateCount(0, end, this.duration);
    }
  }

  private animateCount(start: number, end: number, duration: number): void {
    if (isNaN(end)) {
      this.el.nativeElement.textContent = '0';
      return;
    }

    if (duration <= 0) {
      this.el.nativeElement.textContent = end.toString();
      return;
    }

    const startTime = performance.now();
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const current = Math.round(start + (end - start) * progress);
      this.el.nativeElement.textContent = current.toLocaleString('en-US', { maximumFractionDigits: 0 });
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }
}
